import type { VoteScreen } from "@/appInterface/windows/VoteWindow/VoteScreen";
import { canv } from "@/canv/global";
import { getScaledSize } from "@/utils";
import { toolBase } from "../toolBase";

const SELECTOR_RADIUS = 16;

export class VoteTool extends toolBase {
    TryAction(type: string) {
        if (this.voteScreen === null) {
            this.voteScreen = canv.appInterface.voteWindow.screen;
        }

        const overCorner = this.voteScreen?.overCorner();
        const isOverRect = this.voteScreen?.isOverRect();
        const pt = canv.actionManager.getActionPoint();
        const prePt = canv.actionManager.getPreActionPoint();

        if (type === "mousedown") {
            if (overCorner) {
                this.mousedownOnCorner = overCorner;
            } else if (isOverRect) {
                this.isMousedownOnRect = true;
            }
        } else if (type === "mousemove") {
            if (this.mousedownOnCorner) {
                this.voteScreen?.resize(this.mousedownOnCorner);
            } else if (this.isMousedownOnRect) {
                this.voteScreen?.translate(pt.x - prePt.x, pt.y - prePt.y);
            }

            this.checkCursor();
        } else if (type === "mouseup") {
            if (this.isMousedownOnRect && canv.actionManager.clickMove < 3) {
                const pt = canv.actionManager.getActionPoint();
                const candidates = canv.canvasController.hashGrid?.query(pt.x, pt.y);

                if (candidates) {
                    for (const group of candidates) {
                        if (
                            group.isOverAnyInGroup(false) ||
                            group.isOverVoteSelector() ||
                            this.isOverCircleControl(
                                group.startX + group.width,
                                group.startY + group.height,
                                { x: pt.x, y: pt.y },
                            )
                        ) {
                            this.voteScreen?.selectGroup(group);
                        }
                    }
                }
            }

            this.mousedownOnCorner = null;
            this.isMousedownOnRect = false;
        }
    }

    isOverCircleControl(groupX: number, groupY: number, { x, y }: { x: number; y: number }) {
        const rCanvas = getScaledSize(SELECTOR_RADIUS);
        const dx = x - groupX;
        const dy = y - groupY;
        const distanceSquared = dx * dx + dy * dy;

        return distanceSquared <= rCanvas * rCanvas;
    }

    checkCursor() {
        const overCorner = this.voteScreen?.overCorner();
        const isOverRect = this.voteScreen?.isOverRect();

        if (overCorner) {
            if (this.cursor !== "nwse-resize" && ["leftTop", "rightBottom"].includes(overCorner)) {
                this.chooseCursor("nwse-resize");
            } else if (
                this.cursor !== "nesw-resize" &&
                ["rightTop", "leftBottom"].includes(overCorner)
            ) {
                this.chooseCursor("nesw-resize");
            }
        } else if (isOverRect) {
            if (this.cursor !== "pointer") {
                this.chooseCursor("pointer");
            }
        } else if (this.cursor !== "default") {
            this.chooseCursor("default");
        }
    }

    chooseCursor(cursor: string) {
        document.body.style.cursor = cursor;
        this.cursor = cursor;
    }

    cursor = "default";
    name = "voteTool";
    voteScreen: VoteScreen | null = null;
    mousedownOnCorner: string | null = null;
    isMousedownOnRect = false;
}
